import React, { useEffect } from 'react';

import { Layout } from 'antd';
import classNames from 'classnames';
import routePaths from 'config/routes';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { setFooterHeight } from 'src/actions/appActions';
import BasicFooterCopyright from 'src/components/layout/BasicFooterCopyright';
import BasicPreFooter from 'src/components/layout/BasicPreFooter';
import BasicPreFooterConsumer from 'src/components/layout/BasicPreFooterConsumer';
import { IRootReducers } from 'src/reducers';
import { isConPlatform, useWindowSize } from 'utils';

interface OwnProps {
  hideFooter: boolean;
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    isFooterSticky: state.app.isFooterSticky,
    challenge: state.app.challenge,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({ setFooterHeight }, dispatch);

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

const BasicFooter: NextPage<Props> = ({
  hideFooter,
  isFooterSticky,
  challenge,
  setFooterHeight,
}) => {
  const { isSM } = useWindowSize();

  const router = useRouter();
  const path = router.pathname;
  const isMyAddresses = path == routePaths.PAGES.MY_ACCOUNT.MY_ADDRESSES;
  const isExperience = path == routePaths.PAGES.EXPERIENCE_DETAIL;
  const isContest = path == routePaths.PAGES.CHALLENGE_DETAIL;
  const isScanPage = path == routePaths.PAGES.SCAN.SCAN_INDEX;
  const isQrLanding = path == routePaths.PAGES.QR_LANDING;

  useEffect(() => {
    if (!isExperience && !isContest && !isMyAddresses && !isScanPage) {
      setTimeout(() => {
        setFooterHeight(null);
      }, 0);
    }
  }, [path]);

  const footerClassNames = classNames('basicFooter', {
    basicFooter__sticky:
      (isFooterSticky && challenge) ||
      (isSM && isMyAddresses) ||
      (isSM && isScanPage),
    'basicFooter__sticky--hidden': isFooterSticky === 'hidden',
    'basicFooter__landingButtonFixed': isQrLanding,
  });

  return hideFooter ? null : (
    <Layout.Footer className={footerClassNames}>
      {isConPlatform ? <BasicPreFooterConsumer /> : <BasicPreFooter />}
      <BasicFooterCopyright />
    </Layout.Footer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicFooter);
